import useFetch from "customHooks/useFetch";
import { saveAs } from "file-saver";
import { parsePartialitiesReport } from "helpers/documents";
import { useEffect, useState } from "react";

/**
 *
 * @param {"cxc"|"cxp"} typeReport
 */
export default function usePartialitiesReport(typeReport = "cxc") {
  /** @type {ReturnType<typeof useFetch<import("./types").PartialitieReportItem[]|Blob, object>>} */

  const hook = useFetch("reportes/parcialidades");

  const [parsedData, setParedData] = useState([]);

  useEffect(() => {
    retrieveReport("json");
  }, []);

  /**
   *
   * @param {import("./types").TypeReport} type
   */
  function retrieveReport(type) {
    if (type === "json") setParedData([]);

    return hook
      .fetchData({
        url: `${process.env.REACT_APP_BACKEND}reportes/parcialidades?type=${type}`,
        responseType: type === "json" ? "json" : "blob",
        withCredentials: true,
        method: "GET",
      })
      .then((res) => {
        if (!res.isError) {
          if (type === "json") {
            const parsedItems = parsePartialitiesReport(
              Array.isArray(res.data) ? res.data : []
            ).filter((item) => item.tipo === typeReport);

            setParedData(parsedItems);

            return parsedItems;
          } else {
            if (res.data instanceof Blob) {
              const filename = `Reporte parcialidades ${typeReport.toLocaleUpperCase()} ${new Intl.DateTimeFormat(
                "es-MX",
                {
                  dateStyle: "medium",
                  timeStyle: "long",
                }
              ).format(new Date())}.xlsx`;

              saveAs(res.data, filename);
            }
          }
        }
      })
      .catch(() => []);
  }

  return {
    hook,
    parsedData,
    retrieveReport,
  };
}
